import React, { ElementType } from "react";

interface ModalProps {
  children: React.ReactNode;
  className?: string;
  as?: ElementType;
}

export const ModalTitle = ({
  children,
  className,
  as: Component = "h5",
}: ModalProps) => <Component className={className ?? ""}>{children}</Component>;

/**
 * The scrolling middle of a modal.
 *
 * `Modal` is now a flex column with a real max-height, so the body is the part
 * that gives: `grow` lets it take the slack, `overflow-y-auto` keeps a long
 * form reachable, and `min-h-0` is what actually permits a flex child to
 * shrink below its content — without it the body refuses to compress and the
 * footer buttons are pushed off the bottom of the sheet.
 *
 * Callers keep supplying their own padding; these only add behaviour.
 */
export const ModalBody = ({
  children,
  className,
  as: Component = "div",
}: ModalProps) => (
  <Component className={`grow min-h-0 overflow-y-auto ${className ?? ""}`}>
    {children}
  </Component>
);

/** Pinned below the scrolling body, so the primary action is always reachable. */
export const ModalFooter = ({
  children,
  as: Component = "div",
  className,
}: ModalProps) => (
  <Component className={`shrink-0 ${className ?? ""}`}>{children}</Component>
);
